'use strict';

/**
 * 
 */
module.controller('parameterDetailCtrl',
        [ '$scope', '$rootScope', '$state', 'alertService', 'parameterService', function($scope, $rootScope, $state, alertService, parameterService) {

            $scope.loading = false;
            $scope.parameterCategory = null;
            $scope.parameterType = {};
            $scope.parameterTypes = [];
            $scope.parameter = {};

            $scope.operationType = $state.current.data.type;
            $scope.idParameter = null;

            /**
             * Funcion que se ejecuta cuando se selecciona algún elemento del comboBox de
             * cetegorías, se encarga de iniciarlizar el ComboBox de tipos de acuerdo a la
             * categoría seleccionada.
             * @param constantSelected
             */
            $scope.onConstantCategoryChange = function(constantSelected){
                var paramTypes = PARAMETER_TYPE.values();
                var typesfromCategory = [];
                for(var i = 0 ; i < paramTypes.length ; i++){
                	if(constantSelected && constantSelected[0]){
                		if(constantSelected[0].enumName === paramTypes[i].category.enumName ){
                            typesfromCategory.push(paramTypes[i]);
                        }                		
                	}
                }
                $scope.parameterType = {};
                $scope.parameterTypes = typesfromCategory;
            };

            /**
             * Función que se encarga de recibir un evento de creación o actualización de parámetros
             * @param isValid
             */
            $scope.sendAction = function() {
                if ($scope.operationType == 'create') {
                    alertService.showSwtQuestion('Crear Parámetro', function() {
                        $scope.create();
                    });
                }
                else if ($scope.operationType == 'update'){
                    alertService.showSwtQuestion('Actualizar Parámetro', function() {
                        $scope.update();
                    });
                }
            };

            /**
             * Función para crear un parámetro
             */
            $scope.create = function() {
                $scope.loading = true;
                var createModel = {
                    name: $scope.parameter.name,
                    value: $scope.parameter.value,
                    category: $scope.parameterCategory[0].enumName,
                    type: $scope.parameterType.selected[0].enumName
                };
                
                if($scope.parameter.selected){
                	if($scope.parameter.selected.length > 0){
                		createModel.idParentParameter = $scope.parameter.selected[0].id;
                	}
                }

                parameterService.createParameter(createModel).then(function(response) {
                    $scope.loading = false;
                    $state.go('home.parameterList');
                    alertService.showSuccess('Parámetro registrado en el sistema');
                }, function(response) {
                    $scope.loading = false;
                });
            };

            /**
             * Función que actualiza la información de un parámetro
             * @param parameter
             */
            $scope.update = function() {
                $scope.loading = true;
                var updateModel = {
                    name: $scope.parameter.name,
                    value: $scope.parameter.value,
                    category: $scope.parameterCategory[0].enumName,
                    type: $scope.parameterType.selected[0].enumName
                };
                
                if($scope.parameter.selected){
                	if($scope.parameter.selected.length > 0){
                		updateModel.idParentParameter = $scope.parameter.selected[0].id;
                	}
                }

                parameterService.updateParameter($scope.idParameter, updateModel).then(function(response) {
                    $scope.loading = false;
                    $state.go('home.parameterList');
                    alertService.showSuccess('Parámetro actualizado satisfactoriamente');
                }, function(response) {
                    $scope.loading = false;
                });

            };

            /**
             * Función que cargar la información de un parámetro
             * @param parameter
             */
            $scope.load = function(idParameter) {
                $scope.loading = true;

                parameterService.getParameter(idParameter).then(function(response) {
                    $scope.loading = false;
                    var param = response.getData();

                    $scope.parameter = {
                        name: param.name,
                        value: param.value
                    };
                    
                    if(param.parent){
                    	$scope.parameter.selected = [param.parent];
                    }

                    var categ = getConstantById(eval('PARAMETER_CATEGORY'), param.category);
                    var type = getConstantById(eval('PARAMETER_TYPE'), param.type);

                    $scope.parameterCategory = [];
                    $scope.parameterCategory[0] = categ;
                    
                    $scope.parameterType = {
                        selected: []
                    };
                    
                    $scope.parameterType.selected[0] = type

                }, function(response) {
                    $scope.loading = false;
                });

            };


            /**
             * Si la operación es una actualización se debe cargar la información del parámetro
             */
            if ($scope.operationType == 'update') {
                $scope.idParameter = $state.params.id;
                $scope.load($scope.idParameter);
            }

        } ]);
